import React, { useState } from 'react'
import { ReferenceManyField, BooleanField, FunctionField, DatagridConfigurable, useRecordContext, useNotify } from 'react-admin'
import Box from '@mui/material/Box'
import CustomDateField from 'common/CustomDateField'
import CustomLinkField from 'common/CustomLinkField'
import { parsePrice } from 'utils/helpers'
import CustomPagination from 'common/CustomPagination'
import IconButton from '@mui/material/IconButton'
import RefreshIcon from '@mui/icons-material/Refresh'
import CircularProgress from '@mui/material/CircularProgress'
import Tooltip from '@mui/material/Tooltip'
import axios from 'axios'
import UserService from 'UserService'

import 'styles.scss'
import { FilterExportToolbar } from 'common/FilertExportToolbar'

interface InvoiceRecord {
  id: string
  companyId: string
  accepted: boolean
  [key: string]: any
}

interface FieldProps {
  source?: string
  label?: string
}

const RetriggerXeroButton = ({ source }: FieldProps) => {
  const record = useRecordContext<InvoiceRecord>()
  const notify = useNotify()
  const [loading, setLoading] = useState(false)

  const handleRetriggerXero = async () => {
    if (!record) return

    setLoading(true)
    try {
      await axios.put(
        `/api/workflow/groups_management/companies/${record.companyId}/invoices/${record.id}/requestXero`
      )
      notify('Xero retrigger successful', { type: 'success' })
    } catch (error) {
      notify('Failed to retrigger Xero', { type: 'warning' })
      console.error('Error retriggering Xero:', error)
    } finally {
      setLoading(false)
    }
  }

  if (!record || !record.accepted || !UserService.hasRoles(['ROLE_EXFLUENCY_ADMIN'])) return null

  return (
    <Tooltip title="Retrigger Xero">
      <IconButton
        aria-label="retrigger xero"
        onClick={handleRetriggerXero}
        disabled={loading}
        size="small"
      >
        {loading ? <CircularProgress size={20} /> : <RefreshIcon />}
      </IconButton>
    </Tooltip>
  )
}

const CompanyInvoices = () => {
  return <Box>
    <Box height='50px' />
    <ReferenceManyField
      reference="invoices"
      target="companyId"
      pagination={<CustomPagination />}
      sort={{ field: 'creationDate', order: 'DESC' }}
      perPage={50}
      fullWidth
      className='gray-skin'
    > 
      <FilterExportToolbar showColumns/>
      <DatagridConfigurable resource='invoices' bulkActionButtons={false} className='assigments-datagrid small-row'>
        <CustomLinkField source="id" targetFieldId='id' show label={'Invoice Number'} sortable={false} basePath='invoices' />
        <CustomDateField source="startDate" label={'Start Date'} sortable={false} />
        <CustomDateField source="endDate" label={'End Date'} sortable={false} />
        <CustomDateField source="creationDate" label={'Creation Date'} />
        <FunctionField source='sum' render={(row: any) => <b>{parsePrice(row.sum.value) } {row.sum.currency}</b>} textAlign='right' />
        <BooleanField source='pdf' label={'PDF'} />
        <BooleanField source='accepted' />      
        <CustomDateField source="acceptanceDate" label={'Acceptance Date'} />
        <RetriggerXeroButton label="Retrigger Xero" />
      </DatagridConfigurable>
    </ReferenceManyField>
  </Box>
}

export default CompanyInvoices